import { jsx as _jsx } from "react/jsx-runtime";
import { Row, useDevice } from 'seagull';
export function TextAndInlineSelectRow(param) {
    let { children, inline } = param;
    const { isMobileDevice } = useDevice();
    return /*#__PURE__*/ _jsx(Row, {
        alignItems: "center",
        gap: 4,
        wrap: isMobileDevice,
        inline: inline,
        children: children
    });
}
